export default __webpack_public_path__ + "7b28a6eed25e5826f3b659e911c89fa6.svg";